<template>
    <div>
        <v-form ref="buyEditForm" v-model="valid">
            <v-row>
                <v-col cols="6" md="3">
                    <div class="stp-threshold">
                        <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t200" key="bt200" @input="inputChanged()" @keyup="keyUp" :rules="[rules.isPrice]" :label="$t(`thresholds.buy.t200`)"></v-text-field>
                    </div>
                </v-col>
                <v-col cols="6" md="3">
                    <div class="stp-threshold">
                        <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t400" key="bt400" @input="inputChanged()" @keyup="keyUp" :rules="[rules.isPrice]" :label="$t(`thresholds.buy.t400`)"></v-text-field>
                    </div>
                </v-col>
                <v-col cols="6" md="3">
                    <div class="stp-threshold">
                        <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t600" key="bt600" @input="inputChanged()" @keyup="keyUp" :rules="[rules.required, rules.isPrice]" :label="$t(`thresholds.buy.t600`)">
                            <template slot="append"><font-awesome-icon :class="getthresholdColor(2)" :icon="icon" size="xs"></font-awesome-icon></template>
                        </v-text-field>
                    </div>
                </v-col>
                <v-col cols="6" md="3">
                    <div class="stp-threshold">
                        <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t800" key="bt800" @input="inputChanged()" @keyup="keyUp" :rules="[rules.isPrice]" :label="$t(`thresholds.buy.t800`)">
                            <template slot="append"><font-awesome-icon :class="getthresholdColor(1)" :icon="icon" size="xs"></font-awesome-icon></template>
                        </v-text-field>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import StockHtmlHelper from '../../stocks/StockHtmlHelper'
export default {
    props: ['thresholds'],
    data() {
        return {
            valid: false,
            icon: faCircle,
            stockHtmlHelper: undefined,
            rules: {
                required: value => !!value || this.$t('EditorPanel.errors.required'),
                isPrice: value => {
                    const pattern = /^(\d+(?:[.,]\d{1,4})?)$/;
                    return (
                        pattern.test(value) || !value || this.$t('EditorPanel.errors.invalidPrice')
                    );
                }
            },
            thresholdFieldType: this.$vuetify.breakpoint.mobile ? 'number' : 'text'
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    methods: {
        getthresholdColor(score) {
            return this.stockHtmlHelper.getBadgeColor(score);
        },
        validateForm() {
            return this.$refs.buyEditForm.validate();
        },
        isFormValid() {
            return this.valid;
        },
        resetForm() {
            this.$refs.buyEditForm.reset();
        },
        inputChanged() {
            this.$emit('inputChanged', { valid: this.isFormValid() });
        },
        keyUp(e) {
            if (e.keyCode === 13) {
                this.$emit('submitAsked', { valid: this.isFormValid() });
            }
        }
    },
    watch: {
        valid(val) {
            this.$emit('isFormValid', { valid: val });
        }
    }
}
</script>

<style scoped>
.v-card__actions {
	padding: 0 24px 20px;
}
.symbolInput input{
    text-transform: uppercase;
}

@media screen and (max-width: 750px) {
    .v-text-field__details {
        display: none;
    }
    .container{
        padding: 0;
        padding-bottom: 10px;
    }
    .v-subheader{
        padding: 0;
        height: 25px;
        font-size: large;
    }
    .col-6 {
        padding: 0 10px;
    }
    .stp-threshold {
        padding: 10px 0;
    }
}
</style>
